<div class="one3d-config-canvas-bottom">
  <div class="one3d-config-canvas-mobile" *ngIf="showIntExtButtons">
    <div class="one3d-canvas-btn-wrapper">
      <!-- Configurator Exterior Button Desktop -->
      <button
        class="one3d-canvas-btn one3d-canvas-btn-ext activeButton ion-hide-lg-down one3d-configurator-ext-btn-desktop"
        *ngIf="globalService.viewInterior"
        (click)="viewExterior()"
        translate
      >
        INT_EXT_BTN.EXTERIOR
      </button>
      <!-- Configurator Interior Button Desktop -->
      <button
        class="one3d-canvas-btn one3d-canvas-btn-int activeButton ion-hide-lg-down one3d-configurator-int-btn-desktop"
        *ngIf="!globalService.viewInterior"
        (click)="viewInterior()"
        translate
      >
        INT_EXT_BTN.INTERIOR
      </button>
      
    </div>
    <!-- int-ext-new-btn -->
    <div class="one3d-interior-exterior-new-btn">
      <button
        class="one3d-interior-new-btn ion-hide-lg-up a5"
        *ngIf="globalService.viewInterior && globalService.idea != 0"
        (click)="viewExterior()"
        translate
      >
        <span
          ><img src="assets/img/icons/one3d-ext-icon.svg" alt="interior-icon"
        /></span>
        INT_EXT_BTN.EXT
      </button>
    </div>
    <div class="one3d-interior-exterior-new-btn">
      <button
        class="one3d-exterior-new-btn ion-hide-lg-up a6"
        *ngIf="!globalService.viewInterior && globalService.idea != 0"
        (click)="viewInterior()"
        translate
      >
        <span
          ><img src="assets/img/icons/one3d-int-icon.svg" alt="interior-icon"
        /></span>
        INT_EXT_BTN.INT
      </button>
    </div>
    <!-- new-design-ends -->
    <div
      *ngIf="globalService.viewInterior && numOfSeats == '7 Seater'"
      class="one3d-seating-rows-wrapper one3d-config-seating-rows"
    >
      <ion-select
        interface="popover"
        [placeholder]="'INT_EXT_BTN.SEATING_ROW_1' | translate"
        class="one3d-seating-rows"
        [value]="seatingView"
        (ionChange)="viewSeats($event)"
        mode="md"
        [selectedText]="
          'INT_EXT_BTN.' +
            (seatingView == 'frontSeatView'
              ? 'SEATING_ROW_1'
              : seatingView == 'backSeatView'
              ? 'SEATING_ROW_2'
              : 'SEATING_ROW_3') | translate
        "
      >
        <ion-select-option value="frontSeatView" translate>
          INT_EXT_BTN.1ST_ROW_SEATS
        </ion-select-option>
        <ion-select-option value="backSeatView" translate>
          INT_EXT_BTN.2ND_ROW_SEATS
        </ion-select-option>
        <ion-select-option value="lastSeatView" translate>
          INT_EXT_BTN.3RD_ROW_SEATS
        </ion-select-option>
      </ion-select>
    </div>
    <div
      *ngIf="globalService.viewInterior && numOfSeats === '5 Seater'"
      class="one3d-seating-rows-wrapper one3d-config-seating-rows"
    >
      <ion-select
        interface="popover"
        [placeholder]="'INT_EXT_BTN.1ST_ROW_SEATS' | translate"
        class="one3d-seating-rows"
        [value]="seatingView"
        (ionChange)="viewSeats($event)"
        mode="md"
        [selectedText]="
          seatingView === 'frontSeatView'
            ? 'Seating Rows - 1st Row'
            : seatingView === 'backSeatView'
            ? 'Seating Rows - 2nd Row'
            : 'Seating Rows - 3rd Row'
        "
      >
        <ion-select-option value="frontSeatView" translate>
          INT_EXT_BTN.1ST_ROW_SEATS
        </ion-select-option>
        <ion-select-option value="backSeatView" translate>
          INT_EXT_BTN.2ND_ROW_SEATS
        </ion-select-option>
      </ion-select>
    </div>
  </div>
  <div class="one3d-mobile-seating-config" *ngIf="showIntExtButtons">
    <ion-fab
      class="one3d-mobile-seat-rows"
      slot="fixed"
      vertical="top"
      horizontal="start"
      *ngIf="
        globalService.viewInterior &&
        (numOfSeats === '5 Seater' || numOfSeats === '4 Seater')
      "
    >
      <ion-fab-button class="one3d-mobile-seat-rows-toggle">
        <img src="assets/img/icons/one3d-seat-rows.svg" alt="seat rows" />
      </ion-fab-button>
      <ion-fab-list side="start">
        <ion-fab-button (click)="viewSeatsMobile('backSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">2nd</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
        <ion-fab-button (click)="viewSeatsMobile('frontSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">1st</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>
    <ion-fab
      class="one3d-mobile-seat-rows"
      slot="fixed"
      vertical="top"
      horizontal="start"
      *ngIf="globalService.viewInterior && numOfSeats === '7 Seater'"
    >
      <ion-fab-button class="one3d-mobile-seat-rows-toggle">
        <img src="assets/img/icons/one3d-seat-rows.svg" alt="seat rows" />
      </ion-fab-button>
      <ion-fab-list side="start">
        <ion-fab-button (click)="viewSeatsMobile('lastSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">3rd</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
        <ion-fab-button (click)="viewSeatsMobile('backSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">2nd</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
        <ion-fab-button (click)="viewSeatsMobile('frontSeatView')">
          <ion-text class="ion-text-center fs-12 one3d-color-black">
            <strong class="d-block fw-800">1st</strong>
            <span class="d-block">row</span>
          </ion-text>
        </ion-fab-button>
      </ion-fab-list>
    </ion-fab>
  </div>
  <button
    class="one3d-reset-position-btn ion-hide-lg-down"
    *ngIf="showResetButton && !this.globalService.imageAccessoryOpen"
    (click)="resetToDefaultPosition()"
    translate
  >
    INT_EXT_BTN.VIEW_IN
    <img src="assets/img/icons/one3d-360-icon.svg" alt="360 degree icon" />
  </button>

</div>
<button
class="one3d-acc-close-btn ion-hide-lg-down"
*ngIf="showResetButton && this.globalService.imageAccessoryOpen"
(click)="resetToDefaultPosition()"
>
<img
  src="assets/img/icons/one3d-acc-close-icon.svg"
  alt="close popup icon"
/>
{{ "INT_EXT_BTN.CLOSE" | translate }}
</button>
